import { Navigate, useLocation } from "react-router-dom";

/**
 * `/settings/*` used to work before settings lived under `/home/settings/*`.
 * Redirect preserves path + query (e.g. `/settings/profile` → `/home/settings/profile`).
 */
export default function LegacySettingsRedirect() {
  const location = useLocation();
  const to = `/home${location.pathname}${location.search}`;
  return <Navigate to={to} replace />;
}
